import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import locale from './locale/localeSlice'
import filters from './filters/filtersSlice'
import systemConfig from './systemConfig/systemConfigSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        locale,
        filters,
        systemConfig,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
